export default "__VITE_ASSET__BM_VB470__"